import { Flame, Heart } from "lucide-react";

export const Header = ({ onOpenDonate }) => {
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 backdrop-blur-md bg-[#5C0E1D]/75 border-b border-[rgba(231,176,74,0.28)]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-3 sm:py-4 flex items-center justify-between">
        <a
          href="/"
          data-testid="logo-ask-god"
          className="flex items-center gap-2 sm:gap-3 group"
        >
          <span className="relative shrink-0">
            <Flame
              className="w-6 h-6 sm:w-9 sm:h-9 text-[#E7B04A] flicker"
              strokeWidth={1.5}
              fill="rgba(231,176,74,0.25)"
            />
          </span>
          <span className="font-serif-display font-bold text-2xl sm:text-4xl leading-none tracking-tight text-[#FFFFFF] whitespace-nowrap">
            Ask <span className="italic font-bold text-[#E7B04A]">God</span>
          </span>
        </a>

        <nav className="flex items-center gap-2 shrink-0">
          <a
            href="#about"
            className="hidden sm:inline text-sm uppercase tracking-[0.18em] font-semibold text-[#FBEBD3] hover:text-[#E7B04A] transition-colors px-3 py-2"
            data-testid="nav-about-link"
          >
            About
          </a>
          <button
            data-testid="header-donate-button"
            onClick={onOpenDonate}
            aria-label="Donate"
            className="inline-flex items-center justify-center gap-1.5 sm:gap-2 rounded-full bg-[#E7B04A] hover:bg-[#F5C76B] border-2 border-[#E7B04A] p-2.5 sm:px-5 sm:py-2.5 text-xs sm:text-sm uppercase tracking-[0.12em] sm:tracking-[0.14em] font-bold text-[#5C0E1D] transition-colors font-sans-clean shadow-md whitespace-nowrap"
          >
            <Heart className="w-5 h-5 sm:w-4 sm:h-4" strokeWidth={2.2} fill="#5C0E1D" />
            <span className="hidden sm:inline">Donate</span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
